module.exports = __webpack_public_path__ + "static/media/closeIcon-yellow.ad6056e1.svg";